import { Clock, Eye, Send, MessageSquare, CheckCircle, XCircle, Flame } from 'lucide-react';

/**
 * Get initials from a name
 * @param {string} name - Full name
 * @returns {string} Initials (max 2 characters)
 */
export const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

/**
 * Get status configuration for a customer status
 * @param {string} status - Customer status
 * @returns {Object} Status config with icon, label, color, bg
 */
export const getStatusConfig = (status) => {
  const configs = {
    'hot-opportunity': { icon: Flame, label: 'Hot Opportunity', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)' },
    'appointment-set': { icon: CheckCircle, label: 'Appointment Set', color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)' },
    'offer-sent': { icon: Send, label: 'Offer Sent', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)' },
    'not-interested': { icon: XCircle, label: 'Lost/Declined', color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.1)' },
    'new-opportunity': { icon: Clock, label: 'New Opportunity', color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.1)' },
    'in-appraisal': { icon: Eye, label: 'In Appraisal', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)' },
    'offer-made': { icon: Send, label: 'Offer Made', color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.1)' },
    'acquired': { icon: CheckCircle, label: 'Acquired', color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)' },
    'lost-declined': { icon: XCircle, label: 'Lost/Declined', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)' },
    // Legacy status support
    'hot-lead': { icon: Flame, label: 'Hot Opportunity', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)' },
    'in-conversation': { icon: Send, label: 'Offer Sent', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)' },
    'negotiating': { icon: Send, label: 'Offer Sent', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)' }
  };
  return configs[status] || configs['new-opportunity'];
};

